import React from 'react';
import * as styles from './Button.css';
import cx from 'classnames';
import { Link } from "react-router";

const Button = ({ path = "/", type = "default", children}) => {

    // render html
    return(
        <Link to={path} className={cx(`button`, `type-${type}`)}>
            {children}
        </Link>
    );
}

export default Button;